import { ref } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-655bbef8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footer-btn"
};
import MultipleProductSelectComp from '@/components/CustomMultipleProductSelect.vue';
import { CloseOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { reactive } from 'vue';
import { upsertThresholdPlanFetch } from '@/api/orderMonitor';
import { MODEL_CONFIG, MODEL_ENUM } from '../data';
import { ORDER_LEVEL_OPTIONS } from '../../data';
import { reportEvent } from '@/common';
export default {
  __name: 'addModal',
  props: {
    productList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['reflashTable'],
  setup(__props, {
    expose,
    emit
  }) {
    const drawVisible = ref(false);
    const formData = reactive({
      schemeName: '',
      dbtIds: [],
      calculateModel: [MODEL_ENUM.NORMAL_DISTRIBUTION, MODEL_ENUM.SLOPE],
      enable: 0,
      scale: undefined,
      remark: ''
    });
    const loading = ref(false);
    const formRef = ref();
    const rowId = ref(null);
    const showModal = row => {
      initData();
      drawVisible.value = true;
      if (row !== null && row !== void 0 && row.schemeId) {
        rowId.value = row.schemeId;
        setData(row);
      }
    };
    const onClose = () => {
      formRef.value.resetFields();
      drawVisible.value = false;
    };
    const setData = async row => {
      var _row$modelConfig;
      formData.schemeName = row.schemeName || '';

      // 处理模型数据：后端返回格式为 {modelConfig: {modelList: [0, 1]}}
      if ((_row$modelConfig = row.modelConfig) !== null && _row$modelConfig !== void 0 && _row$modelConfig.modelList && Array.isArray(row.modelConfig.modelList)) {
        formData.calculateModel = row.modelConfig.modelList.map(v => Number(v));
      } else {
        // 默认选中所有模型
        formData.calculateModel = [MODEL_ENUM.NORMAL_DISTRIBUTION, MODEL_ENUM.SLOPE];
      }
      formData.enable = row.enable !== undefined ? row.enable : 0;
      formData.scale = row.scale || undefined;
      formData.remark = row.remark || '';
      formData.dbtIds = row.dbtIds || [];
    };
    const onSave = () => {
      formRef.value.validate().then(async () => {
        try {
          var _formData$dbtIds;
          const params = {
            schemeName: formData.schemeName,
            // 提交时转为后端需要的格式：{modelList: [0, 1]}
            modelConfig: {
              modelList: formData.calculateModel
            },
            enable: formData.enable,
            scale: formData.scale || null,
            remark: formData.remark
          };
          if ((_formData$dbtIds = formData.dbtIds) !== null && _formData$dbtIds !== void 0 && _formData$dbtIds.length) {
            params.dbtIds = formData.dbtIds;
          }
          if (rowId.value) {
            params.schemeId = rowId.value;
          }
          loading.value = true;
          const {
            code
          } = await upsertThresholdPlanFetch(params);
          if (code === '0') {
            message.success('保存成功!');
            emit('reflashTable');
            onClose();
          }
          reportEvent({
            eventName: 'element_use',
            properties: {
              ui_name: '阀值方案',
              element_name: '保存'
            }
          });
        } catch (error) {}
        loading.value = false;
      }).catch(error => {});
    };
    const initData = () => {
      formData.schemeName = '';
      formData.dbtIds = [];
      formData.calculateModel = [MODEL_ENUM.NORMAL_DISTRIBUTION, MODEL_ENUM.SLOPE];
      formData.enable = 0;
      formData.scale = undefined;
      formData.remark = '';
      rowId.value = null;
    };
    expose({
      showModal
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_col = _resolveComponent("a-col");
      const _component_a_row = _resolveComponent("a-row");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      const _component_a_checkbox_group = _resolveComponent("a-checkbox-group");
      const _component_a_radio = _resolveComponent("a-radio");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_a_select_option = _resolveComponent("a-select-option");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_a_modal, {
        placement: "right",
        title: "阀值方案设置",
        width: "600px",
        open: drawVisible.value,
        "onUpdate:open": _cache[6] || (_cache[6] = $event => drawVisible.value = $event),
        class: "plan-draw",
        onClose: onClose,
        closable: false
      }, {
        extra: _withCtx(() => [_createVNode(_unref(CloseOutlined), {
          onClick: onClose,
          class: "close_icon"
        })]),
        default: _withCtx(() => [_createVNode(_component_a_form, {
          model: formData,
          ref_key: "formRef",
          ref: formRef,
          layout: "horizontal",
          "label-col": {
            style: {
              width: '100px'
            }
          },
          class: "plan_form_wrap"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_row, {
            gutter: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 22
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "方案名称",
                name: "schemeName",
                rules: [{
                  required: true,
                  message: '请输入'
                }]
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  value: formData.schemeName,
                  "onUpdate:value": _cache[0] || (_cache[0] = $event => formData.schemeName = $event),
                  placeholder: "请输入方案名称"
                }, null, 8, ["value"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_row, {
            gutter: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 22
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "选择模型",
                name: "calculateModel",
                rules: [{
                  required: true,
                  message: '请至少选择一个模型'
                }]
              }, {
                default: _withCtx(() => [_createVNode(_component_a_checkbox_group, {
                  value: formData.calculateModel,
                  "onUpdate:value": _cache[1] || (_cache[1] = $event => formData.calculateModel = $event)
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MODEL_CONFIG), item => {
                    return _openBlock(), _createBlock(_component_a_checkbox, {
                      key: item.value,
                      value: item.value
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                      _: 2
                    }, 1032, ["value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["value"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_row, null, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 22
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "选择产品"
              }, {
                default: _withCtx(() => [_createVNode(MultipleProductSelectComp, {
                  width: "100%",
                  valueField: "dbtId",
                  labelField: "appName",
                  value: formData.dbtIds,
                  "onUpdate:value": _cache[2] || (_cache[2] = $event => formData.dbtIds = $event),
                  productList: __props.productList,
                  showFooter: true,
                  allowClear: true,
                  maxTagCount: 40
                }, null, 8, ["value", "productList"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_row, {
            gutter: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 22
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "状态"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_radio_group, {
                  value: formData.enable,
                  "onUpdate:value": _cache[3] || (_cache[3] = $event => formData.enable = $event)
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_radio, {
                    value: 0
                  }, {
                    default: _withCtx(() => [_createTextVNode("关闭")]),
                    _: 1
                  }), _createVNode(_component_a_radio, {
                    value: 1
                  }, {
                    default: _withCtx(() => [_createTextVNode("开启")]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["value"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_row, {
            gutter: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 22
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "日订单量级",
                name: "scale",
                rules: [{
                  required: true,
                  message: '请选择日订单量级'
                }]
              }, {
                default: _withCtx(() => [_createVNode(_component_a_select, {
                  value: formData.scale,
                  "onUpdate:value": _cache[4] || (_cache[4] = $event => formData.scale = $event),
                  placeholder: "请选择日订单量级",
                  allowClear: ""
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ORDER_LEVEL_OPTIONS), item => {
                    return _openBlock(), _createBlock(_component_a_select_option, {
                      value: item.value,
                      key: item.value
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                      _: 2
                    }, 1032, ["value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["value"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_row, {
            gutter: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_a_col, {
              span: 22
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "备注",
                name: "remark"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_textarea, {
                  value: formData.remark,
                  "onUpdate:value": _cache[5] || (_cache[5] = $event => formData.remark = $event),
                  rows: 3,
                  placeholder: "请输入备注",
                  showCount: "",
                  maxlength: 200
                }, null, 8, ["value"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_a_button, {
          style: {
            "margin-right": "8px"
          },
          onClick: onClose
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_a_button, {
          type: "primary",
          loading: loading.value,
          onClick: onSave,
          class: "m-l-12"
        }, {
          default: _withCtx(() => [_createTextVNode("提交")]),
          _: 1
        }, 8, ["loading"])])]),
        _: 1
      }, 8, ["open"])]);
    };
  }
};